module.exports = __webpack_public_path__ + "img/4-3.2a0fe9b1.svg";